import VariableDensity from './VariableDensity';

export default VariableDensity;
